import { ALL_SOURCE_KEYS } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import { type FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import styles from './modulation-source-key-picker.module.css'

export interface ModulationSourceKeyPickerProps {
  onPick: (source: string) => void
  questionNumber: number
  totalQuestions: number
}

/**
 * Hard-mode second answer phase (Track 6). After the listener picks the
 * technique, they identify the source key from the full 24-key grid. Both
 * answers must be correct for the question to count.
 *
 * Spec: docs/superpowers/specs/2026-06-02-modulation-lab-v15-design.md §Track 6
 */
export const ModulationSourceKeyPicker: FC<ModulationSourceKeyPickerProps> = props => {
  const { onPick, questionNumber, totalQuestions } = props
  const pickerCopy = useTheoryCopy('modulation-source-picker')

  return (
    <div className={styles.picker}>
      <div className={styles.header}>
        Question {questionNumber} / {totalQuestions} — {pickerCopy?.displayName ?? 'Starting key'}
      </div>
      <div className={styles.keyGrid}>
        {ALL_SOURCE_KEYS.map(key => (
          <Button key={key} type="button" variant="outlined" onClick={() => onPick(key)}>
            {key}
          </Button>
        ))}
      </div>
    </div>
  )
}
